module.exports = __webpack_public_path__ + "media/mypage/images/fa/8-08ad990c4d5adf55d1c221cc9a510043.jpg";